// 法律（移动端）
<template>
  <div class="cmain">
    <mheader></mheader>
    <div class="topimg"></div>
    <div class="center">
      <h1 class="title">法律服务咨询</h1>
      <p
        class="jianjie"
      >根据建筑行业发展动态，针对工程招投标、合同谈判与签订，项目实施过程中诸如工期、质量、造价、担保、保险、损害赔偿、工伤、劳务纠纷等方面的问题，为客户提供专业化法律咨询服务。同时，也可为客户提供企业并购、对外投资合作、公司治理等方面的服务咨询。</p>
      <div class="img"></div>
    </div>

    <mfooter></mfooter>
  </div>
</template>

<script>
import mheader from "../../components/mobileHF/mHeader";
import mfooter from "../../components/mobileHF/mFooter";
export default {
  props: {},
  data() {
    return {};
  },
  mounted() {
    if (this.isMobile()) {
      this.$router.replace("/mLaw"); //移动端跳转路由
    } else {
      this.$router.replace("/law"); //Pc端跳转路由
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  components: {
    mheader,
    mfooter,
  },
};
</script>

<style scoped lang="less">
.cmain {
  .topimg {
    width: 100%;
    height: 8.9rem;
    background: url("../../assets/img/mobile/mBanner/法律.png") 0 0 no-repeat;
    background-size: 100%;
  }
  .center {
    width: 100%;
    padding: 0rem 0.6rem;
    box-sizing: border-box;
    overflow: hidden;
    margin-bottom: 1rem;
    .title {
      opacity: 1;
      font-size: 1rem;
      font-family: Microsoft YaHei Bold, Microsoft YaHei Bold-Bold;
      font-weight: 700;
      text-align: center;
      color: #4279db;
      line-height: 1.4rem;
      margin: 1rem 0rem;
    }
    .jianjie {
      opacity: 1;
      font-size: 0.75rem;
      font-family: Microsoft YaHei Regular, Microsoft YaHei Regular-Regular;
      // font-weight: bolder;
      line-height: 1.3rem;
      text-align: justifyLeft;
      color: #231815;
      text-indent: 2em;
      margin-bottom: 1rem;
    }
    .img {
      width: 100%;
      height: 10rem;
      background: url("../../assets/img/法律/一 拷贝 2@3x.png") 0 0 no-repeat;
      background-size: 100%;
    }
  }
}
</style>
